import { Skeleton } from 'antd';

/**
 * Subscription tab skeleton — Current plan hero + Duration switcher +
 * Compare caption + 3 plan cards. Yangi layout'ga to'liq mos.
 */
export default function SubscriptionSkeleton() {
  return (
    <div
      className="bl-animate-in"
      style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
    >
      {/* Current plan hero placeholder */}
      <div
        style={{
          borderRadius: 20,
          background: 'var(--bl-surface-soft, #eef0f3)',
          padding: '14px 18px 16px',
          minHeight: 168,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton.Input active size="small" style={{ width: 100, height: 11 }} />
          <Skeleton.Input active size="small" style={{ width: 110, height: 22, borderRadius: 999 }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 8 }}>
          <Skeleton.Avatar active size={56} shape="square" style={{ borderRadius: 16 }} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Skeleton.Input active size="small" style={{ width: 110, height: 22 }} />
            <Skeleton.Input active size="small" style={{ width: 150, height: 12 }} />
          </div>
        </div>
      </div>

      {/* Duration switcher placeholder */}
      <Skeleton.Input active size="small" style={{ width: '100%', height: 44, borderRadius: 14 }} />

      {/* Section caption */}
      <Skeleton.Input active size="small" style={{ width: 130, height: 11, marginTop: 4 }} />

      {/* Plan cards */}
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            borderRadius: 18,
            background: 'var(--bl-surface, #fff)',
            border: '1px solid var(--bl-divider, #ebebeb)',
            overflow: 'hidden',
          }}
        >
          {/* Hero band */}
          <div
            style={{
              padding: '16px 16px 14px',
              background: 'var(--bl-surface-soft, #eef0f3)',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            <Skeleton.Avatar active size={44} shape="square" style={{ borderRadius: 13 }} />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
              <Skeleton.Input active size="small" style={{ width: 90, height: 18 }} />
              <Skeleton.Input active size="small" style={{ width: 130, height: 12 }} />
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: '14px 16px 16px' }}>
            <Skeleton.Input active size="small" style={{ width: 150, height: 28, marginBottom: 4 }} />
            <Skeleton.Input active size="small" style={{ width: 200, height: 12, marginBottom: 14 }} />
            <Skeleton active paragraph={{ rows: 3 }} title={false} />
            <Skeleton.Input active size="small" style={{ width: '100%', height: 48, borderRadius: 14, marginTop: 12 }} />
          </div>
        </div>
      ))}
    </div>
  );
}
